import { defaultLocale as DEFAULT_LOCALE, supportedLocales } from '@/i18n/locales'

export interface ReviewTheme {
  name: string
  display_names?: Record<string, string>
  required?: boolean
}

export interface ReviewOperator {
  id: string
  name: string
}

export interface ReviewPrompt {
  session_id: string
  operators: ReviewOperator[]
  themes: ReviewTheme[]
}

/** operatorId -> { themeSlug -> stars (1..5) } draft state */
export interface OperatorRatingDraft {
  themeStars: Record<string, number>
}

export interface SubmitThemeRating {
  theme: string
  stars: number
}

export interface SubmitRatingPayload {
  operatorId: string
  themeRatings: SubmitThemeRating[]
}

/** Resolve a theme's label for the viewer's locale, with fallback chain → default → en → slug. */
export const themeDisplayName = (theme: ReviewTheme, locale: string): string => {
  const lang = (supportedLocales as readonly string[]).includes(locale) ? locale : DEFAULT_LOCALE

  return (
    theme.display_names?.[lang] ||
    theme.display_names?.[DEFAULT_LOCALE] ||
    theme.display_names?.en ||
    theme.name
  )
}
